import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import RelatedProductsList from './RelatedProductsList';
import CategoryHeading from '../CategoryHeading';

const relatedProductsPropertyTypes = {
  title: PropTypes.node,
  products: PropTypes.arrayOf(PropTypes.node),
};

type RelatedProductsProperties = InferProps<
  typeof relatedProductsPropertyTypes
>;

const RelatedProducts = ({
  title = 'Related Products',
  products,
}: RelatedProductsProperties) => (
  <>
    <CategoryHeading>
      {title}
    </CategoryHeading>
    <RelatedProductsList>
      {products}
    </RelatedProductsList>
  </>
);

RelatedProducts.propTypes = relatedProductsPropertyTypes;

export default RelatedProducts;
